import { render, staticRenderFns } from "./SponsorCard.vue?vue&type=template&id=6000f67f&scoped=true"
import script from "./SponsorCard.vue?vue&type=script&lang=js"
export * from "./SponsorCard.vue?vue&type=script&lang=js"
import style0 from "./SponsorCard.vue?vue&type=style&index=0&id=6000f67f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6000f67f",
  null
  
)

export default component.exports